import React from 'react';
import classes from './RadioButtonList.module.scss';

const RadioButtonList = props => (
  <>
    <ul
      className={`checkboxList ${classes.checkboxList} ${
        props.displayLayout && props.displayLayout === 'horizontal' ? classes.horizontalDisplay : ''
      }`}
    >
      {props.list.map(item => (
        <li key={props.name + '_' + item.value}>
          <input
            className=""
            id={props.name + '_' + item.value}
            name={props.name}
            type="radio"
            value={item.label}
            checked={item.checked}
            onChange={() => {
              props.handleChange(item, props.name);
            }}
          />
          <label
            htmlFor={props.name + '_' + item.value}
            tabIndex="0"
            onKeyPress={event => {
              if (event.key === 'Enter') {
                props.handleChange(item, props.name);
              }
            }}
          >
            {item.label}
          </label>
        </li>
      ))}
    </ul>
  </>
);

export default RadioButtonList;
